(function() {
  function getCk(n) {
    var m = document.cookie.match(new RegExp('(^| )' + n + '=([^;]+)'));
    return m ? decodeURIComponent(m[2]) : null;
  }
  function esc(s){ return (s==null?'':String(s)).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function setCk(n, v){ try { document.cookie = n + '=' + encodeURIComponent(v) + '; path=/; max-age=2592000'; } catch(e){} }

  var wrap = document.getElementById('sp-global-progress-wrap');
  if (!wrap) return;

  if (document.querySelector('[data-no-builder="true"]')) {
    wrap.style.display = 'none';
    return;
  }

  var ctx = wrap.getAttribute('data-page-context');

  // Remember the diamond catalog's active filters so "Change diamond" can restore
  // them later (format-agnostic: we just stash the current querystring).
  function captureDiamondFilters(){
    var q = (window.location.search || '').replace(/^\?/, '');
    q = q.split('&').filter(function(p){ return p && p.indexOf('preview_theme_id=') !== 0; }).join('&');
    setCk('_dfilters', q);
  }
  if (ctx === 'diamond-collection') {
    captureDiamondFilters();
    window.addEventListener('pagehide', captureDiamondFilters);
  }

  var diamondRaw = getCk('_diamonmd') || getCk('_diamond');
  var diamond = null;
  if (diamondRaw) { try { diamond = JSON.parse(diamondRaw); } catch(e) {} }
  var hasDiamond = !!(diamond && diamond.sku);

  var ringRaw = getCk('_ring');
  var ring = null;
  if (ringRaw) { try { ring = JSON.parse(ringRaw); } catch(e) {} }
  var hasRing = !!(ring && ring.handle);

  var isFinal = window.location.search.indexOf('view=final-ring') > -1;

  var onSettingPage = (ctx === 'settings-collection' || ctx === 'settings-product');
  var onDiamondPage = (ctx === 'diamond-collection' || ctx === 'diamond-product');

  // BUILD ORDER — follow the path the customer actually built. The first item
  // they SELECT fixes the order (setting-first vs diamond-first) and it is
  // persisted so it never flips later (e.g. on the final page once both exist).
  // Only "Start Over" resets it.
  var buildOrder = getCk('_buildorder'); // 'setting' | 'diamond' | null
  if (!buildOrder) {
    if (hasRing && !hasDiamond) { buildOrder = 'setting'; setCk('_buildorder', 'setting'); }
    else if (hasDiamond && !hasRing) { buildOrder = 'diamond'; setCk('_buildorder', 'diamond'); }
  }
  var settingFirst;
  if (buildOrder) settingFirst = (buildOrder === 'setting');
  else if (onDiamondPage) settingFirst = false;   // entry point fallback (not persisted)
  else settingFirst = true;                        // settings pages + default

  // STATE is the current page's progress — decoupled from order so it never flips.
  function stateOf(kind) {
    if (kind === 'complete') return isFinal ? 'active' : 'upcoming';
    if (isFinal) return 'completed';               // on final page both choices are done
    if (kind === 'setting') {
      if (onSettingPage) return 'active';
      return hasRing ? 'completed' : 'upcoming';
    }
    // diamond
    if (onDiamondPage) return 'active';
    return hasDiamond ? 'completed' : 'upcoming';
  }
  var settingStep  = { label: 'Choose a Setting',     state: stateOf('setting')  };
  var diamondStep  = { label: 'Choose a Diamond',     state: stateOf('diamond')  };
  var completeStep = { label: 'Complete Your Ring',   state: stateOf('complete') };

  var steps = settingFirst
    ? [settingStep, diamondStep, completeStep]
    : [diamondStep, settingStep, completeStep];

  var icons = {
    'Setting': '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="15" r="6"/><path d="M12 9V4"/><path d="M9 5.5L12 4l3 1.5"/><path d="M8 10l-1-3"/><path d="M16 10l1-3"/></svg>',
    'Diamond': '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 6.5h15l3 5-10.5 11L1.5 11.5z"/><path d="M1.5 11.5h21"/><path d="M12 22.5l-4-11 4-5 4 5-4 11"/><path d="M7.5 6.5l4.5 5 4.5-5"/></svg>',
    'Complete': '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="15" r="6"/><path d="M9.5 10.5l2.5-4 2.5 4"/><path d="M9.5 10.5h5"/><path d="M8.5 11l-0.5 0.5"/><path d="M15.5 11l0.5 0.5"/></svg>'
  };

  var html = '<div class="sp-progress">';
  for (var i = 0; i < steps.length; i++) {
    var s = steps[i];
    var cls = 'sp-progress__step';
    if (s.state === 'active') cls += ' sp-progress__step--active';
    else if (s.state === 'completed') cls += ' sp-progress__step--completed';

    var isDiamondStep = s.label.indexOf('Diamond') > -1;
    var isSettingStep = s.label.indexOf('Setting') > -1;
    var iconKey = isSettingStep ? 'Setting' : (isDiamondStep ? 'Diamond' : 'Complete');

    var smallText, mainText;
    if (isSettingStep) {
      if (hasRing && s.state === 'completed') {
        smallText = 'Your setting';
        mainText = 'SETTING';
      } else {
        smallText = 'Select your'; mainText = 'SETTING';
      }
    } else if (isDiamondStep) {
      if (hasDiamond && s.state === 'completed') {
        smallText = 'Your stone';
        var parts = [];
        if (diamond.carat)   parts.push(String(diamond.carat) + 'CT');
        if (diamond.shape)   parts.push(String(diamond.shape).toUpperCase());
        if (diamond.color)   parts.push(String(diamond.color).toUpperCase());
        if (diamond.clarity) parts.push(String(diamond.clarity).toUpperCase());
        mainText = parts.length ? parts.join(' · ') : 'STONE';
      } else {
        smallText = 'Select your'; mainText = 'STONE';
      }
    } else {
      smallText = 'Complete your'; mainText = 'RING';
    }

    var useDiamondThumb = isDiamondStep && hasDiamond && s.state === 'completed';
    var useSettingThumb = isSettingStep && hasRing && s.state === 'completed';
    var thumbSrc = null;
    var dataAttr = '';
    if (useDiamondThumb) {
      thumbSrc = diamond.cover_pic || diamond.image || diamond.img || diamond.thumbnail;
    } else if (useSettingThumb) {
      dataAttr = ' data-setting-thumb';
    }
    if (useDiamondThumb || useSettingThumb) cls += ' sp-progress__step--has-thumb';

    // "Change" routing: a completed step sends the customer back to the relevant
    // CATALOG with their choices pre-filtered (not the single product page).
    var clickUrl = '';
    if (isSettingStep) {
      if (s.state === 'completed') {
        var shp = diamond && (diamond.canonical_shape || diamond.shape);
        clickUrl = '/collections/engagement-rings' + (shp ? ('?filter.v.option.shape=' + encodeURIComponent(shp)) : '');
      } else {
        clickUrl = '/collections/engagement-rings';
      }
    } else if (isDiamondStep) {
      if (s.state === 'completed') {
        var df = getCk('_dfilters');
        clickUrl = '/collections/lab-diamonds' + (df ? ('?' + df) : '');
      } else {
        clickUrl = '/collections/lab-diamonds';
      }
    }
    var clickAttr = clickUrl ? ' onclick="window.location.href=\'' + clickUrl + '\'"' : '';
    var clickCls = clickUrl ? ' sp-progress__step--clickable' : '';

    html += '<div class="' + cls + clickCls + '"' + clickAttr + '>';
    html += '<div class="sp-progress__num">' + (i + 1) + '</div>';
    var changeLink = (s.state === 'completed' && clickUrl) ? '<span class="sp-progress__change">Change</span>' : '';
    html += '<div class="sp-progress__text"' + (isSettingStep ? ' data-setting-text' : (isDiamondStep ? ' data-diamond-text' : '')) + '><span class="sp-progress__text-small">' + esc(smallText) + '</span><span class="sp-progress__text-main">' + esc(mainText) + '</span>' + changeLink + '</div>';
    if (thumbSrc) {
      html += '<div class="sp-progress__thumb"><img src="' + esc(thumbSrc) + '" alt="' + esc(diamond && diamond.shape || 'Diamond') + '"></div>';
    } else if (useSettingThumb) {
      html += '<div class="sp-progress__thumb"' + dataAttr + '></div>';
    } else {
      html += '<div class="sp-progress__icon">' + icons[iconKey] + '</div>';
    }
    html += '</div>';
  }
  html += '<a href="javascript:void(0)" class="sp-progress__restart" id="sp-global-restart">Start Over</a></div>';

  var container = wrap.querySelector('.sp-progress-container');
  if (container) container.innerHTML = html;

  // v47: async fetch only overwrites text on COMPLETED setting step (not active)
  if (hasRing && ring.handle) {
    var handle = ring.handle.indexOf('/products/') === 0 ? ring.handle : ('/products/' + ring.handle);
    fetch(handle + '.js', { credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if (!p) return;
        var vid = parseInt(ring.vid, 10);
        var v = (p.variants || []).find(function(x){ return x.id === vid; });
        var imgUrl = (v && v.featured_image && (v.featured_image.src || v.featured_image))
                     || p.featured_image
                     || (p.images && p.images[0])
                     || null;
        if (imgUrl && imgUrl.indexOf('//') === 0) imgUrl = 'https:' + imgUrl;

        var slot = document.querySelector('.sp-progress__thumb[data-setting-thumb]');
        if (slot && imgUrl) {
          var img = document.createElement('img');
          img.src = imgUrl;
          img.alt = p.title || 'Setting';
          slot.appendChild(img);
        }
        // Only replace the main label on completed steps (thumbnail was already
        // gated on completed). Prevents "Select your SUN BELT SETTING" hybrid.
        var txt = document.querySelector('.sp-progress__step--completed [data-setting-text] .sp-progress__text-main');
        if (txt && p.title) {
          txt.textContent = p.title.toUpperCase();
        }
      })
      .catch(function(){});
  }

  var restart = document.getElementById('sp-global-restart');
  if (restart) {
    restart.addEventListener('click', function() {
      document.cookie = '_ring=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = '_diamonmd=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = '_diamond=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = '_selectedShapes=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = '_buildorder=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = '_dfilters=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      window.location.href = '/collections/engagement-rings';
    });
  }

})();
